export type ModalStateType = {
  id: string;
  data?: Record<string, never>;
};

export const modalIds = {
  DOWNLOAD_HISTORIC: 'download-historic',
  DOWNLOAD_MULTIMEDIA_PHOTOS: 'download-multimedia-photos',
  RELATES_COMMUNICATION_MODAL: 'relates-communication-modal',
  CHANGE_CAMPAIGN_TO_OT_MODAL: 'change-campaign-to-ot-modal',
  ADD_MULTIMEDIA_MODAL: 'add-multimedia-modal',
  DELETE_PHOTO_MODAL: 'delete-photo-modal',
  OPEN_CAMERA_MODAL: 'open-camera-modal',
  ADD_SKETCH_MODAL: 'add-sketch-modal',
  ADD_ACTION_SKETCH_MODAL: 'add-action-sketch-modal',
  VIEW_FULLSCREEN_IMAGE: 'view-fullscreen-image',
  CHANGE_STATE_MODAL: 'change-state-modal',
  TRANSFER_SUBORDER_MODAL: 'transfer-suborder-modal',
  CONFIRM_TRANSFER_MODAL: 'confirm-transfer-modal',
  VERSION_UPDATE_MODAL: 'version-update-modal',
  CHANGE_PASSWORD_MODAL: 'change-password-modal',
  EDIT_TEAM_MODAL: 'edit-team-modal',
  DELETE_TEAM_MODAL: 'delete-team-modal',
  // Grupos de «Importante» (2026-10-29): borrado desde Gestión → Grupos.
  DELETE_USER_GROUP_MODAL: 'delete-user-group-modal',
  EDIT_USER_GROUP_MODAL: 'edit-user-group-modal',
  EDIT_EXTERNAL_COMPANY_MODAL: 'edit-external-company-modal',
  DELETE_EXTERNAL_COMPANY_MODAL: 'delete-external-company-modal',
  // Plantillas de recorrido (2026-08-16): catálogo por tenant desde Gestión.
  EDIT_ROUTE_PRESET_MODAL: 'edit-route-preset-modal',
  DELETE_ROUTE_PRESET_MODAL: 'delete-route-preset-modal',
  // Materiales por equipo (2026-07-31): asignación desde Gestión → Materiales.
  EDIT_MATERIAL_TEAMS_MODAL: 'edit-material-teams-modal',
  VALIDATION_ERRORS_MODAL: 'validation-errors-modal',
  CONFIRM_CLOSE_ORDER_MODAL: 'confirm-close-order-modal',
  PAUSE_SURVEILLANCE_ROUTE: 'pause-surveillance-route',
  NEW_SURVEILLANCE_SEGMENT: 'new-surveillance-segment',
  NEW_DASHBOARD_WIDGET: 'new-dashboard-widget',
  // V4 PR 4 (2026-04-22): timer UI.
  GPS_REQUIRED: 'gps-required',
  CHANGE_DIRECTION: 'change-direction',
  // V4 PR 5 (2026-04-22): vinculación de tramos (P15).
  RELATE_SEGMENT: 'relate-segment',
  // Cross-link 3 (2026-09-22): recorrido ↔ OT en las dos caras.
  RELATE_ORDER_TO_ROUTE: 'relate-order-to-route',
  // V4 D6 (2026-07-06): edición de la causa de parada de un tramo cerrado.
  CHANGE_PAUSE_CAUSE: 'change-pause-cause',
  // rv-recorrido-colgado (2026-07-22): force-close del gestor con hora elegida.
  FORCE_CLOSE_ROUTE: 'force-close-route',
  // Corrección de gestión de un tramo cerrado (spec 2026-07-31).
  EDIT_SEGMENT: 'edit-segment',
  // «Registrar parada» (spec 2026-10-06): partir un tramo por las paradas que
  // la patrulla no pausó, y su Deshacer.
  REGISTER_SEGMENT_STOP: 'register-segment-stop',
  UNDO_SEGMENT_STOP: 'undo-segment-stop',
  // «Tramos revisados» (spec 2026-10-27): confirmar «desmarcar todos».
  UNREVIEW_ALL_SEGMENTS: 'unreview-all-segments',
  // «Transferir tramo» (spec 2026-10-07): mover un tramo a su recorrido.
  TRANSFER_ROUTE_SEGMENT: 'transfer-route-segment',
  MOVE_ROUTE_SEGMENTS: 'move-route-segments',
  // App nativa: falta «Permitir siempre» en la ubicación. Bloqueante, igual
  // que GPS_REQUIRED.
  BACKGROUND_LOCATION_REQUIRED: 'background-location-required',
  // App nativa: falta la ubicación precisa o la ubicación de las fotos y el
  // tenant tiene encendido `feature-photo-geotag`. Bloqueante, igual que el de
  // arriba (spec 2026-09-23 fotos geolocalizadas, § 14 y § 15).
  PHOTO_PERMISSIONS_REQUIRED: 'photo-permissions-required',
  // Prevención P1 (2026-10-15): el cronómetro pregunta antes de seguir un
  // recorrido de otro turno.
  CONTINUE_SHIFT: 'continue-shift',
};

/**
 * Modales que existen para NO tener salida: falta un permiso o el GPS y no se
 * puede seguir. Ni Escape ni un clic fuera los cierran; los cierra su dueño
 * (el guardián que los abrió) cuando detecta que el problema se ha resuelto.
 * Bloquear es honesto porque todos tienen un botón que siempre funciona.
 */
export const UNDISMISSABLE_MODAL_IDS: ReadonlySet<string> = new Set([
  modalIds.GPS_REQUIRED,
  modalIds.BACKGROUND_LOCATION_REQUIRED,
  modalIds.PHOTO_PERMISSIONS_REQUIRED,
]);
